import { DATASET_INDICES } from '../constants.js';

// Creates function to highlight last data point by default
export const createDefaultActiveStateSetter = (chart, lastIndex) => {
  return () => {
    chart.setActiveElements([
      { datasetIndex: DATASET_INDICES.MEAN, index: lastIndex },
      { datasetIndex: DATASET_INDICES.INDICATOR, index: lastIndex },
    ]);
    chart.update('none');
  };
};

// Mouse handlers: restore default state after mouse leave
export const createMouseHandlers = (setDefaultActiveState, delay = 100) => {
  let isMouseOverChart = false;

  return {
    mouseenter: () => {
      isMouseOverChart = true;
    },
    mouseleave: () => {
      isMouseOverChart = false;

      setTimeout(() => {
        if (!isMouseOverChart) {
          setDefaultActiveState();
        }
      }, delay);
    },
  };
};
